import { render, staticRenderFns } from "./Duvidas.vue?vue&type=template&id=466d0c16&scoped=true&"
import script from "./Duvidas.vue?vue&type=script&lang=js&"
export * from "./Duvidas.vue?vue&type=script&lang=js&"
import style0 from "./Duvidas.vue?vue&type=style&index=0&id=466d0c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d0c16",
  null
  
)

export default component.exports